
<template>
    <div class="notification">
        <v-btn small @click="openNotification" flat icon class="nav-icon ma-0" color="white">
            <v-badge overlap color="secondary">
                <span slot="badge" v-if="count != 0">{{count}}</span>
                <v-icon color="white">mdi-bell-outline</v-icon>
            </v-badge>
        </v-btn>
        <LoginRegisterModal :dialog="loginRegisterModalShow" @hide="loginRegisterModalShow = false" event-name="redirectHome"></LoginRegisterModal>
    </div>
</template>


<script>
    import LoginRegisterModal from "./LoginRegisterModal";
    export default {
        components: {LoginRegisterModal},
        data() {
            return {
                count : 0,
                loginRegisterModalShow : false,
            }
        },
        methods: {
            async countUnreadNotification(){
                if (this.$store.state.user != null) {
                    await axios.get('/api/notification_unread_count')
                        .then(res => {
                            this.count = res.data;
                        })
                        .catch(err => {
                            if (err.response.data.message === "Server Error"){
                                this.countUnreadNotification();
                            }
                        });
                }
            },
            openNotification(){
                if (this.$store.state.user != null){
                    this.$router.push({path: "/notification"});
                }
                else{
                    this.loginRegisterModalShow = true;
                }

            }
        },
        mounted(){
            if (this.$store.state.user != null) {
                this.countUnreadNotification();
            }
            EventBus.$off('redirectHome');
            EventBus.$on('redirectHome', () => {

                this.$router.push({path: "/notification"});

            });
        }
    }

</script>
